export const ADMISSION_CONFIG = {
  academicYear: "2026-2027",
  academicYearShort: "2026-27",
  deadlineStr: "April 30, 2026",
  deadlineFull: "April 30, 2026 00:00:00",
};
